import i18n from 'i18next'

// The backend sends species names in Thai. English shows these instead
// (longest name first so "กุ้งขาว" wins over "กุ้ง").
export const SPECIES_EN: [string, string][] = [
  ['กุ้งขาวแวนนาไม', 'Vannamei shrimp'],
  ['กุ้งก้ามกราม', 'Giant river prawn'],
  ['กุ้งกุลาดำ', 'Black tiger shrimp'],
  ['กุ้งขาว', 'White shrimp'],
  ['กุ้ง', 'Shrimp'],
  ['ปลา', 'Fish'],
  ['หอย', 'Shellfish'],
  ['ปู', 'Crab'],
]

const isEnglish = () => (i18n.language ?? '').startsWith('en')

/** Replaces Thai species names inside [text] with English ones. */
export const replaceSpeciesNamesEn = (text: string) =>
  SPECIES_EN.reduce((out, [th, en]) => out.split(th).join(en), text)

/** Species name for display: English name in English, as-is otherwise. */
export const speciesDisplayName = (species?: string | null) =>
  isEnglish() ? replaceSpeciesNamesEn(species ?? '') : species ?? ''

/**
 * A label followed by the species, e.g. "ประวัติการย้าย" + "ปลา". Thai/Burmese
 * keep the old concatenation; English reads "Transfer history (Fish)".
 */
export const labelWithSpecies = (label: string, species?: string | null) => {
  if (!species) return label
  return isEnglish() ? `${label} (${replaceSpeciesNamesEn(species)})` : `${label}${species}`
}
